import { buttonsFromSerializedInAppMessage as ye } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class ModalMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    o,
    a,
    p,
    m,
    n,
    u,
    c,
    d,
    f,
    l,
    g,
    j,
    v,
    x,
    z,
    h,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
    B,
    C,
  ) {
    super(
      e,
      r,
      void 0,
      s,
      t,
      i,
      o,
      a,
      (p = p || InAppMessage.DismissType.MANUAL),
      m,
      n,
      u,
      c,
      d,
      f,
      l,
      g,
      j,
      v,
      x,
      z,
      h,
      w,
      y,
      S,
      (b = b || InAppMessage.CropType.FIT_CENTER),
      void 0,
      k,
      q,
      A,
      B,
      C,
    ),
      (this.Io = InAppMessage.TextAlignment.CENTER);
  }
  gt() {
    return super.gt(ModalMessage.es);
  }
  static Zn(e) {
    return new ModalMessage(
      e[InAppMessage.ss.pa],
      e[InAppMessage.ss.ma],
      e[InAppMessage.ss.xs],
      e[InAppMessage.ss.ua],
      e[InAppMessage.ss.ca],
      e[InAppMessage.ss.URI],
      e[InAppMessage.ss.fa],
      e[InAppMessage.ss.da],
      e[InAppMessage.ss.la],
      e[InAppMessage.ss.ga],
      e[InAppMessage.ss.ns],
      e[InAppMessage.ss.ja],
      e[InAppMessage.ss.xa],
      e[InAppMessage.ss.za],
      e[InAppMessage.ss.ha],
      e[InAppMessage.ss.va],
      e[InAppMessage.ss.wa],
      e[InAppMessage.ss.ya],
      e[InAppMessage.ss.Sa],
      e[InAppMessage.ss.ba],
      e[InAppMessage.ss.ka],
      e[InAppMessage.ss.qa],
      e[InAppMessage.ss.Aa],
      ye(e[InAppMessage.ss.Ba]),
      e[InAppMessage.ss.Ca],
      e[InAppMessage.ss.Ea],
      e[InAppMessage.ss.CSS],
      e[InAppMessage.ss.Fa],
      e[InAppMessage.ss.LANGUAGE],
      e[InAppMessage.ss.ks],
    );
  }
}
ModalMessage.es = InAppMessage.Eo.ta;
